// ProductContext.js
import React, { createContext, useState, useEffect, useContext } from "react";
import { BusinessContext } from "./BusinessContext";

export const ProductContext = createContext();

const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const { business, loading } = useContext(BusinessContext);

  useEffect(() => {
    const fetchProducts = async () => {
      // Ensure business is fully loaded and account_id is present
      if (loading || !business?.account_id) return;

      console.log("===========> business", business.account_id);
      try {
        const response = await fetch(
          `https://api.octavio.co/products/filter?account_id=${business.account_id}`
        );
        if (!response.ok) {
          throw new Error(`Error fetching products: ${response.status}`);
        }
        const data = await response.json();

        const formattedProducts = data.map((product) => ({
          id: product?.product_id,
          slug: product?.product_name.toLowerCase().replace(/\s+/g, "-"),
          image:
            product?.product_photo_urls.length > 0
              ? product?.product_photo_urls[0].url
              : "",
          category:
            product?.product_category[0]?.category_name || "Uncategorized",
          title: product?.product_name,
          price: product?.product_price,
          description: product?.product_description,
        }));

        setProducts(formattedProducts);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, [business, loading]);

  return (
    <ProductContext.Provider value={{ products }}>
      {children}
    </ProductContext.Provider>
  );
};

export default ProductProvider;
